import { forwardRef } from 'react';

interface WaveformProps {
    isUser?: boolean;
}

const Waveform = forwardRef<HTMLDivElement[], WaveformProps>(({ isUser = false }, ref) => {
    const barCount = 7;
    const maxDelay = 300; // max stagger in ms

    // Generate symmetric sine-based delays [0, ~150, ~260, 300, ~260, ~150, 0]
    const delays = Array(barCount)
        .fill(0)
        .map((_, i) =>
            Math.round(
                Math.sin((i / (barCount - 1)) * Math.PI) * maxDelay
            )
        );

    return (
        <div className="wave-container flex h-10 w-[4.2em] gap-0.5 items-center">
            {delays.map((delay, index) => (
                <div
                    key={`wave-bar-${isUser ? 'user' : 'agent'}-${index}`}
                    ref={(el) => {
                        if (ref && 'current' in ref && Array.isArray(ref.current)) {
                            ref.current[index] = el;
                        }
                    }}
                    className={`wave-bar rounded-full ${isUser ? 'user-wave' : 'bg-white'}`}
                    style={{
                        height: '10%',
                        animationDelay: `${delay}ms`,
                    }}
                />
            ))}
        </div>
    );
});

Waveform.displayName = 'Waveform';
export default Waveform;